import { ColorType } from '__core/shared/model/global/Color.enum';
import { IconType } from '__core/shared/model/global/Icon.enum';
import stAlertDialog from './alertDialog.component';
import stAlertMessage from './alertMessage.component';
import audio from './audio.directive';
import stAvatar from './avatar.component';
import stBackButton from './backButton.directive';
import stColorPicker from './colorPicker.component';
import stConfirmDialog from './confirmDialog.component';
import stCustomField from './customField.directive';
import d3ChartBars from './d3ChartBars.directive';
import d3ChartBullet from './d3ChartBullet.directive';
import d3ChartDualYAxes from './d3ChartDualYAxes.directive';
import d3ChartGauge from './d3ChartGauge.directive';
import d3ChartGaugeMultiple from './d3ChartGaugeMultiple.directive';
import d3ChartLine from './d3ChartLine.directive';
import d3ChartStacked from './d3ChartStacked.directive';
import autoOpen from './datepickerAutoOpen.directive';
import customize from './datepickerCustomize.directive';
import stDeleteConfirmation from './deleteConfirmation.component';
import stEmailValidation from './emailValidation';
import enforcePassword from './enforcePassword.directive';
import stFilePreview from './filePreview.component';
import stFormActions from './formActions.component';
import stFormWarning from './formWarning.component';
import stIconPicker from './iconPicker.component';
import img from './img.directive';
import stImportFields from './importFields.component';
import importFieldsService from './importFields.service';
import stInfiniteScrolling from './infiniteScrolling.directive';
import stInputDefaultValue from './inputDefaultValue.directive';
import stInputInsertValue from './inputInsertValue.directive';
import stLabelsFilter from './labels.filter';
import listService from './list.service';
import listImportantService from './listImportant.service';
import listInstanceService from './listInstance.service';
import listServiceNew from './listNew.service';
import stListOrderBy from './listOrderBy.filter';
import stMenuClick from './menuClick.directive';
import stMergeFields from './mergeFields.component';
import mergeFieldsService from './mergeFields.service';
import stNotesFilter from './notes.filter';
import stPagination from './pagination.component';
import stPaginationFilter from './pagination.filter';
import stPhoneNumber from './phoneNumber.directive';
import stPhoneValidation from './phoneValidation';
import stProgressbar from './progressbar.directive';
import stReportFilter from './reportFilter.directive';
import stReportTitle from './reportTitle.directive';
import stSelectOptionConvertToNumber from './selectOptionConvertToNumber.directive';
import setCallingCode from './setCallingCode.directive';
import stStartingLetter from './startingLetter.component';
import stStartingLetterFilter from './startingLetter.filter';
import stChosenFilter from './stChosenFilter.component';
import stDisabledOverlay from './stDisableOverlay.component';
import stDisallowNegativeNumber from './stDisallowNegativeNumber.directive';
import stringToNumber from './stringToNumber.directive';
import stTimeInput from './stTimeInput.directive';
import TimeUnit from './timeUnit.model';
import uiService from './ui.service';
import stUpload from './upload.component';
import stWhenScrolled from './whenScrolled.directive';

export default angular
  .module('st.Core.UI', [
    'st.Core.Event',
    'angular.img',
    'angular-loading-bar',
    'angularResizable',
    'ngAnimate',
    'ngImgCrop',
    'ngMaterial',
    'ngMap',
    'ngMessages',
    'ngWig',
    'ui.sortable'
  ])
  .component('stAlertDialog', stAlertDialog)
  .component('stAlertMessage', stAlertMessage)
  .directive('audio', audio)
  .component('stAvatar', stAvatar)
  .directive('stBackButton', stBackButton)
  .factory('Color', () => ColorType)
  .component('stColorPicker', stColorPicker)
  .component('stConfirmDialog', stConfirmDialog)
  .directive('stCustomField', stCustomField)
  .directive('d3ChartBars', d3ChartBars)
  .directive('d3ChartBullet', d3ChartBullet)
  .directive('d3ChartDualYAxes', d3ChartDualYAxes)
  .directive('d3ChartGauge', d3ChartGauge)
  .directive('d3ChartGaugeMultiple', d3ChartGaugeMultiple)
  .directive('d3ChartLine', d3ChartLine)
  .directive('d3ChartStacked', d3ChartStacked)
  .directive('autoOpen', autoOpen)
  .directive('customize', customize)
  .component('stDeleteConfirmation', stDeleteConfirmation)
  .directive('stEmailValidation', stEmailValidation)
  .directive('enforcePassword', enforcePassword)
  .component('stFilePreview', stFilePreview)
  .component('stFormActions', stFormActions)
  .component('stFormWarning', stFormWarning)
  .factory('Icon', () => IconType)
  .component('stIconPicker', stIconPicker)
  .directive('img', img)
  .component('stImportFields', stImportFields)
  .service('importFieldsService', importFieldsService)
  .directive('stInfiniteScrolling', stInfiniteScrolling)
  .directive('stInputDefaultValue', stInputDefaultValue)
  .directive('stInputInsertValue', stInputInsertValue)
  .filter('stLabelsFilter', stLabelsFilter)
  .service('listService', listService)
  .service('listImportantService', listImportantService)
  .service('listInstanceService', listInstanceService)
  .service('listServiceNew', listServiceNew)
  .filter('stListOrderBy', stListOrderBy)
  .directive('stMenuClick', stMenuClick)
  .component('stMergeFields', stMergeFields)
  .service('mergeFieldsService', mergeFieldsService)
  .filter('stNotesFilter', stNotesFilter)
  .component('stPagination', stPagination)
  .filter('stPagination', stPaginationFilter)
  .directive('stPhoneNumber', stPhoneNumber)
  .directive('stPhoneValidation', stPhoneValidation)
  .directive('stProgressbar', stProgressbar)
  .directive('stReportFilter', stReportFilter)
  .directive('stReportTitle', stReportTitle)
  .directive('stSelectOptionConvertToNumber', stSelectOptionConvertToNumber)
  .directive('setCallingCode', setCallingCode)
  .component('stStartingLetter', stStartingLetter)
  .filter('stStartingLetter', stStartingLetterFilter)
  .component('stChosenFilter', stChosenFilter)
  .component('stDisabledOverlay', stDisabledOverlay)
  .directive('stDisallowNegativeNumber', stDisallowNegativeNumber)
  .directive('stringToNumber', stringToNumber)
  .directive('stTimeInput', stTimeInput)
  .factory('TimeUnit', TimeUnit)
  .service('uiService', uiService)
  .component('stUpload', stUpload)
  .directive('stWhenScrolled', stWhenScrolled);
